// @flow

import React, { memo, useCallback } from 'react';

import PropTypes from 'prop-types';
import { Box, Paper, Tooltip } from '@mui/material';
import style from './HeightMapToggle.module.less';
import ToggleButton from '@mui/material/ToggleButton';
import { Landscape } from '@mui/icons-material';
import { useHasFeatures } from 'js/context/PermissionContext';
import FeatureConstants from 'js/constants/FeatureConstants';
import { blue } from '@mui/material/colors';
import clsx from 'clsx';
import { useLangFile } from 'js/context/LanguageContext';
import { useFarm } from '../../../context/AccountContext';

const HeightMapToggle = (props: HeightMapToggle.propTypes) => {
  const LangFile = useLangFile();
  const farm = useFarm();
  const enabled = useHasFeatures(FeatureConstants.HEIGHT_MAPS_KORTFORSYNINGEN);

  const onToggle = useCallback(() => {
    if (enabled) {
      props.onToggle(!props.showHeightMap);
    }
  }, [props.showHeightMap, props.onToggle, enabled]);

  if (!farm.cvr) {
    return null;
  }

  return (
    <Box
      className={style.Box}
      sx={{
        pt: 1,
      }}
    >
      <Paper elevation={2} className={clsx({ [style.Paper]: true, [style.Disabled]: !enabled })}>
        <Tooltip title={LangFile.HeightMapToggle.disabledTooltip} disableHoverListener={enabled}>
          <span>
            <ToggleButton
              value="check"
              disabled={!enabled}
              selected={props.showHeightMap}
              onChange={onToggle}
            >
              <Landscape width={24} height={24} htmlColor={enabled ? blue['A700'] : 'white'} />
            </ToggleButton>
          </span>
        </Tooltip>
      </Paper>
    </Box>
  );
};

HeightMapToggle.propTypes = {
  showHeightMap: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default memo(HeightMapToggle);
